import { useNavigate } from "react-router-dom";

export const validateUserAuth = () => {
  const navigate = useNavigate;
  const rawJWT = localStorage.getItem("jwtToken");
  if (!rawJWT) {
    navigate("/login");
    return;
  }
  const jwt = rawJWT.split("Bearer ")[1];
  if (!jwt || jwt === "") {
    localStorage.removeItem("jwtToken");
    navigate("/login");
    return;
  }

  const payload = atob(jwt.split(".")[1]);
  const parsedJWT = JSON.parse(payload);

  if (new Date(payload * 100).getTime() <= new Date().getTime()) {
    localStorage.removeItem("jwtToken");
    navigate("/login");
    return;
  }
  //const brand = parsedJWT.organization;
  return parsedJWT;
};

export const validateAdminAuth = () => {
  const navigate = useNavigate;
  const rawJWT = localStorage.getItem("jwtToken");
  if (!rawJWT) {
    navigate("/login");
    return;
  }
  const jwt = rawJWT.split("Bearer ")[1];
  if (!jwt || jwt === "") {
    navigate("/login");
    return;
  }
  const payload = atob(jwt.split(".")[1]);
  const parsedJWT = JSON.parse(payload);

  if (!parsedJWT.isAdmin) {
    return false;
  }

  if (new Date(payload * 100).getTime() <= new Date().getTime()) {
    localStorage.removeItem("jwtToken");
    navigate("/login");
    return;
  }
  //const brand = parsedJWT.organization;
  return parsedJWT;
};

export const truncateLongText = (text, amount) => {
  const shortened = text.slice(0, amount);
  const ellipsis = text.length > 15 ? "..." : "";
  return shortened + ellipsis;
};

export const formatDate = (date) => {
  let month = new Date(date).getMonth() + 1;
  let day = new Date(date).getDate();
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  const year = new Date(date).getFullYear();
  return month + "/" + day + "/" + year;
};
